import React from 'react';
import akbar from '../assets/akbar.jpg';
import govind from '../assets/sunny.jpg';
import test from '../assets/nimra.jpg'
import fiza from '../assets/fiza.jpg'
import { motion } from "framer-motion";
import { useTheme } from './ThemeContext';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'aos/dist/aos.css';
import AOS from "aos"


function Team() {
  const { isDarkMode } = useTheme();

  const data = [
    {
      img: govind,
      name: 'Govind Kumar',
      passion: 'English Mentor'
    },
    {
      img: akbar,
      name: 'Ghulam Akbar',
      passion: 'Mathematics Mentor'
    },
    {
      img: fiza,
      name: 'Fizza Memon',
      passion: 'Chemisty Mentor'
    },
    {
      img: test,
      name: 'Nimra Bakhtawar',
      passion: 'Physics Mentor'
    }
  ];



  AOS.init({
    duration: 1200,
    easing: 'ease-in-out',
    once: true
  });
  return (
    <>

      <div id='team' className='mx-auto'>
        <div className="mt-20 py-1">
          <motion.div
            className="text-white mx-auto text-center text-2xl dark:shadow-yellow-300 dark:shadow-lg font-extrabold bg-[#235191] 
            self-center lg:w-[292px] w-[200px] md:w-[250px] justify-center items-center   lg:py-4 py-2 md:py-3 rounded-[32px] max-md:mt-10 lg:px-5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            MEET OUR TEAM
          </motion.div>
          <div
            className=" px-10 md:px-20 lg:px-28 grid mt-6 sm:grid-flow-col md:grid-rows-2 lg:flex gap-16 lg:gap-12 justify-center"
          >
            {data.map((d) => (
              <div key={d.name} data-aos="zoom-in-up" className="bg-[#3FE0A5] mt-8 w-72 h-96 lg:h-80 lg:w-56 text-black rounded-xl">
                <div className='h-56 bg-[#235191] flex justify-center items-center rounded-t-xl'>
                  <img src={d.img} alt="" className="h-44 w-44 rounded-full" />
                </div>

                <div className="flex flex-col items-center justify-center gap-4 p-4">
                  <p className="text-xl font-semibold">{d.name}</p>
                  <p className="text-center">{d.passion}</p>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    
    </>

  )
}

export default Team;
